export enum PeriodicityTypes {
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
  Once = 4,
}
